import type { RouteDefinition } from 'types/routes'
import type { DataPathState } from 'types/state'

type SharedDataState = DataPathState<'shared'>

const pages = {
  welcome: {
    path: '/welcome',
    cluster: 'cluster_my_profile',
    isExcludedFromProgressBarOrStepper: true,
    id: 'welcome',
    stateKey: 'age_bucket',
    isValidatedStep: true,
    required: true,
  },
  gender: {
    path: '/gender',
    cluster: 'cluster_my_profile',
    isExcludedFromProgressBarOrStepper: true,
    id: 'gender',
    stateKey: 'gender',
    isValidatedStep: true,
    required: true,
  },
} as const satisfies Record<string, RouteDefinition<SharedDataState>>

const pagesMap = Object.values(pages)

export const SHARED_ROUTES = {
  pages,
  pagesMap,
}
